








import { Component, Prop, Vue } from "vue-property-decorator";
import { UserRoles } from "@/models/auth/AuthenticatedUser";
import { TranslateResult } from "vue-i18n";

@Component
/**
 * Displays a given user role as badge
 */
export default class RoleBadge extends Vue {
  /**
   * The role identifier
   */
  @Prop({ required: true, type: String }) readonly role!: UserRoles;

  /**
   * possible user roles
   */
  public roles = UserRoles;

  /**
   * translate the user role
   * @param role
   */
  translate(role: UserRoles): TranslateResult {
    switch (role) {
      case UserRoles.ANON: {
        return this.$i18n.t("components.roleBadge.anon");
      }
      case UserRoles.MOD: {
        return this.$i18n.t("components.roleBadge.mod");
      }
      case UserRoles.ADMIN: {
        return this.$i18n.t("components.roleBadge.admin");
      }
      default: {
        return "No translation found!";
      }
    }
  }

  /**
   * get badge variant based on user role
   * @param role
   */
  getVariant(role: UserRoles): string {
    switch (role) {
      case UserRoles.ANON: {
        return "info";
      }
      case UserRoles.MOD: {
        return "primary";
      }
      case UserRoles.ADMIN: {
        return "warning";
      }
      default: {
        return "danger";
      }
    }
  }
}
